import React from 'react';
import './NoCourseDisplay.css';
import { Box, Typography } from '@mui/material';
import { NoCourseDisplayProps } from './NoCourseDisplay.props';

export const NoCourseDisplay: React.FC<NoCourseDisplayProps> = ({
  ...props
}: NoCourseDisplayProps) => {
  return (
    <>
      <Box className={'no_course_display'}>
        <Typography className={'no_course_content'}>{props.contents}</Typography>
        <Typography className={'no_course_sub_content'}>{props.sub_content}</Typography>
      </Box>
    </>
  );
};
